import { Loading } from "components/Loading/loading";
import { Textbox } from "components/Textbox/Textbox";
import { useEffect, useRef, useState } from "react";
import { trans } from "utils/helpers";
import { ItemMainPropertyVariation } from "../../../components/ItemMainPropertyVariation/ItemMainPropertyVariation";
import { CKEditor } from "@ckeditor/ckeditor5-react"
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document'
import { Toast } from "components/ToastShow/ToastAlert";
import { MessageType } from "types/enum";


interface MainFormPropsType {
    id?: any,
    mode?: any,
    inTab?: any,
    formRef?: any,
    data?:any;
    checkData: any;

    submitMain?: (data) => void;

}

export const MainForm = ({
    id,
    mode,
    inTab,
    formRef,
    data,
    checkData,
    submitMain,
 
  
}: MainFormPropsType) => {


    const [resetForm, setResetForm] = useState(false);
    const [selectedItemMainPropertyValues, setSelectedItemMainPropertyValues] = useState<any>();
    const [descriptions, setDescriptions] = useState<any>({Description: checkData.Description , DescriptionEN:checkData.DescriptionEN,summaryDescription:""});
    const [editor, setEditor] = useState<any>();
    const [editorData, setEditorData] = useState<any>(data?.DetailedDescription	);

     function formSubmit(event) {
        event.preventDefault();    
             let data ={
                Code: (checkData.ItemMainPropertyId? checkData?.ParentCode :checkData?.ParentCode+ event.target?.Code?.value).replace("undefined","") ,
              //  Alias : event.target.Alias.value,
                //  TechnicalCode : mode=="create" ?"" :event.target.TechnicalCode?.value,کامنت شد چون دلیل خالی بودن کد فنی نمیدانستیم
                  TechnicalCode : event.target.TechnicalCode?.value,
                 Description : (!checkData.ItemMainPropertyId||mode=="view") ?  event.target.Description.value:checkData.Description  ,
                 DescriptionEN :(!checkData.ItemMainPropertyId||mode=="view")? event.target.DescriptionEN.value:checkData.DescriptionEN ,
                 SummaryDescription :checkData.ItemMainPropertyId?"":  event.target.SummaryDescription.value,
                 SummaryDescriptionEN : checkData.ItemMainPropertyId?"": event.target.SummaryDescriptionEN.value,
                 DetailedDescription : editorData,
                 SelectedItemMainProperty: checkData.ItemMainPropertyId,
                 SelectedItemMainPropertyValues:selectedItemMainPropertyValues? selectedItemMainPropertyValues.map(item=>(item.Id)):[]
             }
             if(checkData.ItemMainPropertyId&& (!selectedItemMainPropertyValues ||selectedItemMainPropertyValues?.length==0)){
            //    Toast(trans(`Msg_ErrorNoSelectedLine`) , "error")
            Toast(trans(`Msg_ErrorNoSelectedLine`) , MessageType.error)

             }else{
                 submitMain&&  submitMain(data)
             }
    }
    

    useEffect(() => {
        if ( mode === "create"){
            setResetForm(true);
        }
    }, [ mode]);

    useEffect(() => {
        if (resetForm) {
            setResetForm(false);
        }

    }, [resetForm]);

    return (

        <form className="Main-form py-2" id={"ItemForm"} name={"main"} ref={formRef} onSubmit={formSubmit}>
            <div className="card">
            { (mode != "create" && data)||(mode == "create") ?
                <div className="card-body">
                    <div className="row">
                        {(!checkData.ItemMainPropertyId||mode=="view")?
                        <>
                        <div className="col-2  ">
                            
                     
                            <Textbox
                        
                                autoFocus={true}
                                textboxType="text"
                                asNumber={true}
                                textboxName="Code"
                                required
                                resetForm={resetForm}
                                customClass={"arrow-none"}
                                UsepadWithZeros={true}
                                maxLength={+checkData.CodeLength}
                                addOnValue={checkData ? checkData?.ParentCode+"":checkData?.ParentCode}
                                defaultValue={data?.Code ? data.Code.replace(checkData?.ParentCode,"") : checkData?.Code}
                                labelText={trans("itemcode") + ( mode !== "create" ? "" : `  (${"طول مجاز"} : ${checkData.CodeLength})`)}
                                mode={checkData.ItemMainPropertyId?"view" :  mode}
                                />
                 
                            {/* <div className="col-auto  text-end pt-1"
                            style={{padding:'4px 8px',borderRadius:'5px 0px 0px 5px',marginTop:'5.7px',backgroundColor:'#e9ecef',height:'27.5px',
                                border:'1px solid #ced4da',
                                borderRight:'0px'

                            }}
                            >
                            {checkData ? checkData?.ParentCode+"":checkData?.ParentCode}
                            </div> */}
                          
                        </div>
                        <div className="col-2">
                            <Textbox
                                textboxType="text"
                                textboxName="TechnicalCode"
                                resetForm={resetForm}
                                defaultValue={data?.TechnicalCode ? data.TechnicalCode : null}
                                labelText="TechnicalCode"
                                mode={mode}
                                />
                        </div>
                        <div className="col-3">
                            <Textbox
                                onChange={(e)=>{setDescriptions({...descriptions ,summaryDescription:e.target.value ,Description:checkData.Description+" "+e.target.value  })}}
                                textboxType="text"
                                textboxName="SummaryDescription"
                                resetForm={resetForm}
                                defaultValue={data?.SummaryDescription ? data.SummaryDescription :  null }
                                labelText="itemSummaryDescription"
                                required={!checkData.ItemMainPropertyId }
                                mode={mode}
                                />
                        </div>
                        </> :<></>   
                    }
                    {(!checkData.ItemMainPropertyId||mode=="view")&&
                        <div className="col-4">
                            <Textbox
                                withChangeDir={true}
                                //onBlurHandler={(e)=>{if(e!=descriptions.Description ) setDescriptions({...descriptions ,Description:e })}}
                                onChange={(e)=>{setDescriptions({...descriptions ,Description:e.target.value })}}

                                required={!checkData.ItemMainPropertyId }
                                textboxType="text"
                                textboxName="Description"
                                resetForm={resetForm}
                                defaultValue={(data?.Description&&mode!="create")	? data?.Description	 : ((descriptions.Description ? descriptions.Description:  checkData.Description ))}
                                labelText="itemDescription"
                                mode={mode}
                            />
                        </div>}
                        {(!checkData.ItemMainPropertyId||mode=="view")&&
                        <div className="col-3">
                            <Textbox
                                onBlurHandler={(e)=>{setDescriptions({...descriptions ,SummaryDescriptionEN:e })}}
                                textboxType="text"
                                textboxName="SummaryDescriptionEN"
                                resetForm={resetForm}
                                defaultValue={data?.SummaryDescriptionEN ? data.SummaryDescriptionEN : null}
                                labelText="itemSummaryDescriptionEN"
                                mode={mode}
                                />
                        </div>
                            }
                        {(!checkData.ItemMainPropertyId||mode=="view")&&
                        <div className="col-3">
                            <Textbox
                                onBlurHandler={(e)=>{setDescriptions({...descriptions ,DescriptionEN:e })}}
                                textboxType="text"
                                textboxName="DescriptionEN"
                                resetForm={resetForm}
                                defaultValue={data?.DescriptionEN  ? data?.DescriptionEN :  (descriptions.DescriptionEN ? descriptions.DescriptionEN: descriptions.SummaryDescriptionEN)}
                                labelText="itemDescriptionEN"
                                mode={mode}
                                />
                        </div>
                            }
                        </div>
             
                    {checkData.ItemMainPropertyId ?
                        <ItemMainPropertyVariation checkData={checkData} showLeafMode={true} SelectedItemMainPropertyValues={setSelectedItemMainPropertyValues} ItemMainPropertyId={checkData.ItemMainPropertyId}ItemMainPropertyDescription={checkData.ItemMainPropertyDescription}  />:<></>
                    }
                       <div className="row mt-2 ">
                        <div className="col-12">
                            <span>{trans('DetailedDescription')}</span>
                            <CKEditor
                                data={editorData}
                                disabled={mode == "view" && "true"}
                                onReady={editor => {
                                    editor.ui.getEditableElement().parentElement.insertBefore(
                                        editor.ui.view.toolbar.element,
                                        editor.ui.getEditableElement()
                                    );
                                    setEditor(editor)
                                }}
                                onError={(error, { willEditorRestart }) => {
                                    if (willEditorRestart) {
                                        editor.ui.view.toolbar.element.remove();
                                    }
                                }}
                                onOk={(editor) => {
                                    editor.insertHtml(editorData)
                                }}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setEditorData(data)
                                }}
                                editor={DecoupledEditor}
                                config={{
                                    removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"]
                                }}
                            />
                        </div>

                    </div>
                </div>
                :
                <Loading/>
                }
            </div>
          <button  type="submit"  className="d-none" id="hidebutton" name="hidebutton" >
          </button>
        </form>
    );
}